import { ICombination } from '../../AssignResults/Context/AssignResults.context';

export const isHorse = ({
  format: {
    format: { prefix }
  }
}: ICombination) => prefix === 'horse';
